import React from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from '@dev/ee-components';

import { SelectTrackingRadioProps, AddContactParams } from '../AddInterface';

export const SelectTrackingRadio = (props: SelectTrackingRadioProps): JSX.Element => {
    const { postContactsParams, setAddContactParam } = props;
    const { t } = useTranslation();

    return (
        <Radio
            name="addContactsSelectTracking"
            id="add-contacts-select-tracking-radios"
            value={postContactsParams.consentTracking}
            onChange={(e): void => {
                setAddContactParam(AddContactParams.ConsentTracking, e.target.value);
            }}
            labelPlacement="end"
            radios={[
                {
                    id: 'select-tracking-agree',
                    label: t('yes'),
                    value: 'Allow',
                },
                {
                    id: 'select-tracking-disagree',
                    label: t('no'),
                    value: 'Deny',
                },
                {
                    id: 'select-tracking-unknown',
                    label: t('idontknow'),
                    value: 'Unknown',
                },
            ]}
        />
    );
};
